export default __webpack_public_path__ + "static/media/404.60d821c9.svg";